import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export default function FilesPage() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { const { data } = await api.get("/files"); setFiles(data); setLoading(false); })(); }, []);
  return (
    <div className="p-8 max-w-6xl">
      <h1 className="font-display text-3xl font-bold mb-2">Files</h1>
      
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <table data-testid="files-list" className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-left">
            <tr>
              <Th>Filename</Th><Th>SHA-256</Th><Th className="text-right">Bytes</Th><Th>Backend</Th><Th>Uploaded</Th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="p-6 text-center text-slate-500 font-mono text-xs">loading…</td></tr>}
            {!loading && files.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-slate-500">No files.</td></tr>}
            {files.map((f) => (
              <tr key={f.id} data-testid={`file-row-${f.id}`} className="border-b border-slate-100">
                <td className="px-4 py-2.5 font-mono text-xs">{f.filename}</td>
                <td className="px-4 py-2.5 font-mono text-[11px] text-slate-500 truncate max-w-[16ch]">{f.sha256.slice(0, 16)}…</td>
                <td className="px-4 py-2.5 numeric text-right">{f.bytes.toLocaleString()}</td>
                <td className="px-4 py-2.5 text-xs">{f.storage_backend}</td>
                <td className="px-4 py-2.5 numeric text-xs text-slate-500">{fmtDate(f.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
function Th({ children, className = "" }) { return <th className={`px-4 py-2.5 text-[11px] text-slate-500 text-slate-500 font-medium ${className}`}>{children}</th>; }
